import styled from '@emotion/styled';

import { PopoverContent } from '~/ui/core/popover/Popover';

export const StyledPopoverContent = styled(PopoverContent)(({ theme }) => ({
    alignItems: 'flex-end',
    backgroundColor: theme.colors.gray[100],
    borderRadius: theme.borderRadius.xxxl,
    boxShadow: theme.shadows.large,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.xl,
    padding: theme.spacing.xl,
    width: '350px',
}));

export const StyledContentWrapper = styled.div(({ theme }) => ({
    alignItems: 'flex-end',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.xl,
    width: '100%',
}));

export const SwitchesWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.xl,
    width: '100%',
}));

export const SwitchRow = styled.div(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing.xl,
    justifyContent: 'space-between',
    width: '100%',
}));

export const SwitchLabel = styled.span(({ theme }) => ({
    ...theme.typography.body.S.regular,
    color: theme.colors.black[700],
    flex: 1,
}));

export const ButtonRow = styled.div(({ theme }) => ({
    alignItems: 'flex-start',
    display: 'flex',
    gap: theme.spacing.xl,
    justifyContent: 'flex-end',
}));
